var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartToggled = function SvgHeartToggled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m7.62 2.1.38.442.38-.442A3.637 3.637 0 0 1 11.146.833l.001-.5.001.5a3.676 3.676 0 0 1 2.68 6.201l-.007.007-5.702 5.926a.167.167 0 0 1-.24 0l-5.7-5.924h-.001A3.676 3.676 0 0 1 4.85.832h.002A3.637 3.637 0 0 1 7.621 2.1Z",
    fill: "#fff",
    stroke: "#D64309"
  })));
};
export default SvgHeartToggled;